var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMLworkspaceSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ML") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.75 0,1.66666667 L0,11.6666667 C0,12.5833333 0.654545455,13.3333333 1.45454545,13.3333333 L5.09090909,13.3333333 L5.09090909,14.1666667 C5.09090909,14.625 5.41818182,15 5.81818182,15 L10.1818182,15 C10.5818182,15 10.9090909,14.625 10.9090909,14.1666667 L10.9090909,13.3333333 L14.5454545,13.3333333 C15.3454545,13.3333333 16,12.5833333 16,11.6666667 L16,1.66666667 C16,0.75 15.3454545,0 14.5454545,0 Z M14.4646465,12.5 L1.53535354,12.5 C1.09090909,12.5 0.727272727,12.0625 0.727272727,11.5277778 L0.727272727,1.80555556 C0.727272727,1.27083333 1.09090909,0.833333333 1.53535354,0.833333333 L14.4646465,0.833333333 C14.9090909,0.833333333 15.2727273,1.27083333 15.2727273,1.80555556 L15.2727273,11.5277778 C15.2727273,12.0625 14.9090909,12.5 14.4646465,12.5 Z M12.3636364,4.16666667 L5.81818182,4.16666667 C5.41818182,4.16666667 5.09090909,4.54166667 5.09090909,5 C5.09090909,5.45833333 5.41818182,5.83333333 5.81818182,5.83333333 L12.3636364,5.83333333 C12.7636364,5.83333333 13.0909091,5.45833333 13.0909091,5 C13.0909091,4.54166667 12.7636364,4.16666667 12.3636364,4.16666667 Z M12.3636364,7.5 L5.81818182,7.5 C5.41818182,7.5 5.09090909,7.875 5.09090909,8.33333333 C5.09090909,8.79166667 5.41818182,9.16666667 5.81818182,9.16666667 L12.3636364,9.16666667 C12.7636364,9.16666667 13.0909091,8.79166667 13.0909091,8.33333333 C13.0909091,7.875 12.7636364,7.5 12.3636364,7.5 Z M4.36363636,4.16666667 L2.90909091,4.16666667 L2.90909091,5.83333333 L4.36363636,5.83333333 L4.36363636,4.16666667 Z M4.36363636,7.5 L2.90909091,7.5 L2.90909091,9.16666667 L4.36363636,9.16666667 L4.36363636,7.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-new",
    transform: "translate(-31.000000, -466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ML",
    transform: "translate(31.000000, 466.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/device/dvr_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Fill",
    fill: "#418AFE",
    mask: "url(#mask-2)",
    x: -0.727272727,
    y: -2.5,
    width: 17.4545455,
    height: 20
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLworkspaceSvg);
export default __webpack_public_path__ + "static/media/MLworkspace_svg.a9dad6e839afa54c511128c3fb031e62.svg";
export { ForwardRef as ReactComponent };